export const LOGIN_ROUTE = 'https://login.class4kids.co.uk';
export const LOGIN_CHECK_URL = 'rest/v1/authentication/login-check';
export const AUTHENTICATE = {
  url: 'rest/v1/authentication/login',
  recaptcha: {
    collection: true,
    action: 'Login',
  },
};
